<div class="container" fxLayout="column">
  <app-breadcrumb [url]="goback"></app-breadcrumb>
  <mat-card>
    <mat-card-subtitle>
      <h3>{{ queryParams.id ? "Edição" : "Cadastro" }}</h3>
    </mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="form" (submit)="onSubmit()" fxLayout="column">
        <div
          fxLayout="column"
          fxLayoutAlign="space-between stretch"
          fxFlex="100"
        >
          <div fxLayout="row" fxFlex="100">
            <mat-form-field
              appearance="outline"
              fxFlex="50"
              fxFlex.lt-md="auto"
            >
              <mat-label>Nome</mat-label>
              <input matInput formControlName="name" />
              <mat-hint
                *ngIf="!form.get('name').valid && form.get('name').touched"
                class="error__input"
              >
                {{ form.get("name").errors | errorMessageFG }}
              </mat-hint>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxFlex="100">
            <mat-form-field appearance="outline" fxFlex="30" fxFlex.lt-md="100">
              <mat-label>Token</mat-label>
              <input
                matInput
                [type]="hideToken ? 'password' : 'text'"
                formControlName="token"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                (click)="hideToken = !hideToken"
                [attr.aria-label]="'hideToken password'"
                [attr.aria-pressed]="hideToken"
              >
                <mat-icon>{{
                  hideToken ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <mat-hint
                *ngIf="!form.get('token').valid && form.get('token').touched"
                class="error__input"
              >
                {{ form.get("token").errors | errorMessageFG }}
              </mat-hint>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxFlex="100">
            <div fxLayout="column">
              <mat-label>Ambiente Padrão</mat-label>
              <mat-slide-toggle formControlName="default" color="primary">
                {{
                  form.get("default").value ? "SIM" : "NÃO"
                }}</mat-slide-toggle
              >
            </div>
          </div>

          <div fxLayout="row" fxFlex="100" class="m_t_15">
            <div fxLayout="column">
              <mat-label>Ativo</mat-label>
              <mat-slide-toggle formControlName="active" color="primary">
                {{ form.get("active").value ? "SIM" : "NÃO" }}</mat-slide-toggle
              >
            </div>
          </div>
        </div>

        <div
          class="btn__footer__container"
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <button
            mat-raised-button
            type="submit"
            color="primary"
            class="btn__add"
          >
            Confirmar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
